import React, { useEffect } from 'react'
import CapsuleOrderProvider from '../../components/Orders/New/CapsuleOrderContext'
import CapsuleOrder from '../../components/Orders/New/CapsuleOrder'
import { useLocation, useNavigate } from 'react-router-dom';

const NewOrderPage = () => {
    const location = useLocation();
    const capsuleIds = location.state?.capsuleIds || null;
    const navigate = useNavigate();
    const path = location.pathname || '/clients';
    console.log(path)
    const redirectPath = path.replace('/commander', '')
    
    useEffect(() => {
    if (!capsuleIds) {
            navigate(redirectPath, { replace: true });
    }
    }, [capsuleIds, redirectPath]);

    if (!capsuleIds) {
        return null;
}

    return (
        <CapsuleOrderProvider capsuleIds={capsuleIds}>
            <CapsuleOrder />
        </CapsuleOrderProvider>
    )
}

export default NewOrderPage
